import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  useMediaQuery,
  InputAdornment,
  OutlinedInput,
  TextField,
  Typography,
  useTheme,
  Skeleton,
  Dialog,
  Chip,
  Avatar,
  Stack,
  Divider,
  CardContent,
  CardActions,
  CardHeader,
  Tooltip,
} from "@mui/material";
import { useFormik } from "formik";
import {
  useGetMeetingHolidayQuery,
  useCreateTaskNoteMutation,
  useGetWorkshopHistoryRecordQuery,
  useDoneTaskMutation,
  useDeleteWorkshopRegistrationsMutation,
  useGetAllWorkshopQuery,
  useGetUserQuery,
  useGetAllHolydaysArrayQuery,
  useGetTaskQuery,
  useGetUserInfoOnyQuery,
  useGetCustomerQuery,
  useGetTeamQuery,
  useGetAllTaskSubjectQuery,
  useGetAllPolicyGroupByQuery,
  useGetTaskCategoryQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
  IMeetingCategory,
  IWorkShopHistory,
  ITeam,
  IWorkShop,
  IUserInfo,
  IPolicy,
  ICustomer,
  IMeetingCategory2,
  IUserAdmin,
  IMeetingHistory,
} from "../../../Api/Interface/api.interface";
import { useStyles } from "../../../theme/appStyles";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import { Badge } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import DatePicker, { DateObject } from "react-multi-date-picker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import GroupIcon from "@mui/icons-material/Group";
import { BASENAME } from "../../../config/index";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { green, red } from "@mui/material/colors";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import AlertPopup from "../../../Components/Delete/Done";
// import RescheduleMeeting from "../Edit/rescheduleMeeting";
import NewPopUpDepartment from "../Edit/index";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReactQuill from "react-quill";
import SendIcon from "@mui/icons-material/Send";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { FaEdit, FaTrash, FaExchangeAlt } from "react-icons/fa";
import { GrStatusGood } from "react-icons/gr";
import { IoPricetagsOutline } from "react-icons/io5";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { styled } from "@mui/material/styles";

interface HolidayFormValues {
  holidays: DateObject[];
  note: string;
}

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);

const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const variantPropName = (unit: string) => {
  switch (unit) {
    case "name":
      return "Name";
    case "email":
      return "E-mail";
    case "phone_number":
      return "Phone Number";
    case "workshop_date":
      return "Workshop Date";
    case "status":
      return "Status";
    case "message":
      return "Message";
    case "no_of_participants":
      return "No of Participants";
    default:
      return "";
  }
};

const statusIcon = {
  Created: <BiSolidMessageSquareAdd color="green" size={17} />,
  Modified: <FaEdit color="orange" />,
  Deleted: <FaTrash color="red" />,
  ChangedBranch: <FaExchangeAlt color="orange" />,
  ChangedStatusGreen: <GrStatusGood color="green" />,
  ChangedStatusOrange: <GrStatusGood color="orange" />,
  storeChanged: <BiSolidMessageSquareAdd size={17} color="green" />,
  priceChanged: <IoPricetagsOutline size={17} color="red" />,
};

const isEmpty = (value: any) =>
  value === null || value === undefined || value === "" || value === "-";

const getStatusType = (oldValue: any, newValue: any) => {
  // console.log("🔍 Checking status:", {
  //   oldValue,
  //   newValue,
  //   oldEmpty: isEmpty(oldValue),
  //   newEmpty: isEmpty(newValue),
  // });

  const oldEmpty = isEmpty(oldValue);
  const newEmpty = isEmpty(newValue);

  if (oldEmpty && !newEmpty) {
    return "Created"; // only new value exists
  } else if (!oldEmpty && !newEmpty) {
    return "Modified"; // both values exist
  } else if (!oldEmpty && newEmpty) {
    return "Deleted"; // only old value exists
  }
  return null; // both empty (no change)
};

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { id: meetingId } = useParams<{ id: string }>();

  const { showErrorMessage, showMessage } = useNotifier();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [selectedCoursing, setSelectedCoursing] = useState<IWorkShop | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState<IWorkShop | null>(
    null
  );
  const [openDialogMeeting, setOpenDialogMeeting] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IWorkShop | null>(
    null
  );
  const [openDoneMeeting, setOpenDoneMeeting] = useState(false);
  const [meetingToDone, setMeetingToDone] = useState<IWorkShop | null>(null);

  const containerRef = useRef<HTMLDivElement | null>(null);
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [newDepartment, { isLoading: meetingUPIsLoading }] =
    useCreateTaskNoteMutation();

  const { data: userData } = useGetUserQuery();
  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetAllWorkshopQuery({
    searchText: "",
    staffId: userId || "",
    clientId: "",
    id: String(meetingId),
    fromDate: null,
    toDate: null,
    categoryId: "",
    multi_final_status_filter: [],
  });

  const {
    data: meetingHistoryRecordData,
    isLoading: meetingHistoryRecordIsLaoding,
  } = useGetWorkshopHistoryRecordQuery(
    {
      searchText: "",
      staffId: "",
      clientId: "",
      id: String(meetingId),
      meeting_Date: "",
    },
    {
      pollingInterval: 2000,
    }
  );

  const { data: holydaysData, isLoading: holidaysIsLoading } =
    useGetAllHolydaysArrayQuery({
      searchText: "",
      id: "",
    });

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetTaskQuery({
    searchText: "",
    staffId: userId || "",
    clientId: "",
    id: "",
    meeting_Date: "",
  });
  const { data: clientData, isLoading: cilentIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const { data: staffData, isLoading: staffIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: meetingAllData, isLoading: meetingAllIsLoading } =
    useGetAllTaskSubjectQuery({
      searchText: "",
      id: "",
    });

  const {
    data: policyData,
    isLoading: policyIsLoading,
    refetch: policyRefetch,
  } = useGetAllPolicyGroupByQuery({
    searchText: "",
    id: "",
    policyCustomerId: "",
  });

  const {
    data: getAllMeetingCategoryData,
    isLoading: meetingCategoryIsLoading,
  } = useGetTaskCategoryQuery({
    searchText: "",
  });

  const { data: policyAllData, isLoading: policyAllIsLoading } =
    useGetAllPolicyGroupByQuery({
      searchText: "",
      id: "",
      policyCustomerId: "",
    });

  const { data: userAllData, isLoading: userIsLoading } =
    useGetUserInfoOnyQuery({
      searchText: "",
    });

  const fristIndexMeeting = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IWorkShop;
    }
    return null;
  }, [data]);

  const meetingHistoryRecord: IWorkShop[] = Array.isArray(
    meetingHistoryRecordData?.data
  )
    ? (meetingHistoryRecordData?.data as IWorkShop[])
    : [];

  const historyRecords: IWorkShop[] = Array.isArray(
    meetingHistoryRecordData?.data
  )
    ? (meetingHistoryRecordData?.data as IWorkShop[])
    : [];

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as ICustomer[];
  }, [clientData?.data]);

  const staffList = useMemo(() => {
    return (staffData?.data ?? []) as ITeam[];
  }, [staffData?.data]);

  const policyList = useMemo(() => {
    return (policyData?.data ?? []) as IPolicy[];
  }, [policyData?.data]);

  const meetingCategoryList = useMemo(() => {
    return (getAllMeetingCategoryData?.data ?? []) as IMeetingCategory2[];
  }, [getAllMeetingCategoryData?.data]);

  const policyAllList = useMemo(() => {
    return (policyAllData?.data ?? []) as IPolicy[];
  }, [policyAllData?.data]);

  const userList = useMemo(() => {
    return userAllData?.data as IUserAdmin[];
  }, [userAllData?.data]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [cliendList]);

  const staffOptions = useMemo(() => {
    if (!Array.isArray(staffList)) return [];
    return staffList.map((cust) => ({
      label: `${toProperCase(cust.teamFirstName)} ${toProperCase(
        cust.teamLastName
      )}`,
      value: cust.id,
    }));
  }, [staffList]);

  const policyOptions = useMemo(() => {
    if (!Array.isArray(policyList)) return [];
    return policyList.map((cust) => ({
      label: `${cust.policyNumber}`,
      value: cust.id,
    }));
  }, [policyList]);

  const meetingCategoryOptions = useMemo(() => {
    if (!Array.isArray(meetingCategoryList)) return [];
    return meetingCategoryList.map((cust) => ({
      label: `${cust.name}`,
      value: cust.id,
    }));
  }, [meetingCategoryList]);

  const clientMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    staffList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [staffList]);

  const meetingCategoryMap = useMemo(() => {
    const map = new Map();
    meetingCategoryList?.forEach((category) => {
      map.set(category.id, category.name);
    });
    return map;
  }, [meetingCategoryList]);

  const allPolicyMap = useMemo(() => {
    const map = new Map();
    policyAllList?.forEach((category) => {
      map.set(category.id, category.policyNumber);
    });
    return map;
  }, [policyAllList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.staff}`);
    });
    return map;
  }, [userList]);

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    // If scrolled less than 100px from bottom, hide arrow; else show
    if (scrollHeight - scrollTop - clientHeight > 100) {
      setShowScrollDown(true);
    } else {
      setShowScrollDown(false);
    }
  };

  // Scroll to bottom function
  const scrollToBottom = () => {
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToBottom();
  }, [meetingHistoryRecord]);

  const handleOpenDialog = (coursing: IWorkShop) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDialogMeeting = (coursing: IWorkShop) => {
    setSelectedMeeting(coursing);
    setOpenDialogMeeting(true);
  };

  const handleCloseDialogMeeting = () => {
    setSelectedMeeting(null);
    setOpenDialogMeeting(false);
  };

  const handleOpenDeletePopup = (coursing: IWorkShop) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleOpenDonePopup = (coursing: IWorkShop) => {
    setMeetingToDone(coursing);
    setOpenDoneMeeting(true);
  };

  const handleCloseDonePopup = () => {
    setMeetingToDone(null);
    setOpenDoneMeeting(false);
  };

  const formikMessageEdit = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: String(meetingId),
      note: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: String(meetingId),
          note: values.note,
        };
        const addCompanyResponse = await newDepartment(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          // showMessage(addCompanyResponse.message);
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValidMessageEdit = useMemo(() => {
    return formikMessageEdit.values.note === "" ||
      formikMessageEdit.values.id === ""
      ? false
      : true;
  }, [formikMessageEdit.values]);

  const [deleteCategory] = useDeleteWorkshopRegistrationsMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
        navigate(`/workshop/list`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting");
    }
  };

  const [deleteDoneMeeting] = useDoneTaskMutation();
  const handleDeleteDoneMeeting = async (id: string) => {
    try {
      const response = await deleteDoneMeeting(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDoneMeeting(false);
        navigate(`/client/task`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting done");
    }
  };

  const renderReminderChip = (label: string, enabled?: boolean) => (
    <Chip
      label={label}
      color={enabled ? "success" : "error"}
      icon={enabled ? <CheckIcon /> : <CancelIcon />}
      variant="outlined"
      size="small"
      sx={{
        borderColor: enabled ? green[600] : red[400],
        color: enabled ? green[800] : red[600],
        m: "4px",
      }}
    />
  );

  const getChangedFields = (
    current: IWorkShopHistory,
    prev: IWorkShopHistory | null,
    maps: {}
  ) => {
    if (!prev) return [];

    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (
      field: keyof IWorkShopHistory,
      value: any
    ): string => {
      if (value === undefined || value === null) return "-";

      switch (field) {
        case "workshop_date":
          return dayjs(value).format("MMM D, YYYY");
        case "phone_number":
          return formatPhoneNumberForDisplay(value);
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IWorkShopHistory)[] = [
      "name",
      "email",
      "phone_number",
      "workshop_date",
      "status",
      "message",
      "no_of_participants",
    ];

    return fieldsToCheck
      .map((field) => {
        if (current[field] !== prev[field]) {
          return {
            field,
            oldValue: formatFieldValue(field, prev[field]),
            newValue: formatFieldValue(field, current[field]),
          };
        }
        return null;
      })
      .filter(Boolean) as {
      field: keyof IWorkShopHistory;
      oldValue: string;
      newValue: string;
    }[];
  };

  const getCreatedFields = (current: IWorkShopHistory, maps: {}) => {
    const formatTime = (time: string) =>
      dayjs(`1970-01-01T${time}`).format("hh:mm A");

    const formatFieldValue = (
      field: keyof IWorkShopHistory,
      value: any
    ): string => {
      if (value === undefined || value === null || value === "") return "";

      switch (field) {
        case "workshop_date":
          return dayjs(value).format("MMM D, YYYY");
        case "phone_number":
          return formatPhoneNumberForDisplay(value);
        default:
          return String(value);
      }
    };

    const fieldsToCheck: (keyof IWorkShopHistory)[] = [
      "name",
      "email",
      "phone_number",
      "workshop_date",
      "status",
      "message",
      "no_of_participants",
    ];

    return fieldsToCheck
      .map((field) => {
        const formatted = formatFieldValue(field, current[field]);
        if (formatted) {
          return { field, value: formatted };
        }
        return null;
      })
      .filter(Boolean) as {
      field: keyof IWorkShopHistory;
      value: string;
    }[];
  };

  if (meetingCategoryIsLoading || userIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={4} md={12} sm={12} xs={12}>
          <Card
            elevation={3}
            sx={{
              height: "100%",
              borderRadius: setCardBRadius,
              // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
              // backgroundColor: theme.palette.cardAdd.bgColor,
              p: 1,
              // minHeight: "100vh",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: 3,
                    // background: "linear-gradient(to bottom, #f9f9f9, #fff)",
                    // border: "1px solid #e0e0e0",
                  }}
                >
                  <CardHeader
                    avatar={
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          width: 60,
                          height: 60,
                          fontSize: 24,
                          fontWeight: "bold",
                        }}
                      >
                        {fristIndexMeeting?.name?.charAt(0).toUpperCase() || (
                          <GroupIcon />
                        )}
                      </Avatar>
                    }
                    action={
                      <IconButton aria-label="settings">
                        {/* <MoreVertIcon /> */}
                      </IconButton>
                    }
                    title={
                      <Typography
                        className={classes.mL1Heading}
                        fontWeight={700}
                      >
                        {fristIndexMeeting?.name || "Untitled Meeting"}
                      </Typography>
                    }
                    subheader={
                      (fristIndexMeeting?.workshop_date ||
                        fristIndexMeeting?.no_of_participants) && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            mt: 0.5,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          {[
                            fristIndexMeeting?.workshop_date
                              ? ` ${dayjs(
                                  fristIndexMeeting.workshop_date
                                ).format("MMM D, YYYY")}`
                              : null,
                            fristIndexMeeting?.email
                              ? ` ${fristIndexMeeting.email}`
                              : null,
                            fristIndexMeeting?.phone_number
                              ? ` ${formatPhoneNumberForDisplay(
                                  fristIndexMeeting.phone_number
                                )}`
                              : null,
                          ]
                            .filter(Boolean)
                            .map((text, idx, arr) => (
                              <span key={idx}>
                                {text}
                                {idx < arr.length - 1 && " | "}
                              </span>
                            ))}
                        </Typography>
                      )
                    }
                    sx={{
                      background: theme.palette.cardAdd.thirdBgColor,
                    }}
                  />

                  <CardContent>
                    {fristIndexMeeting?.no_of_participants && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          mt: 3,
                          px: 2,
                          py: 2,
                          backgroundColor: "#f5f5f5",
                          borderRadius: 2,
                        }}
                      >
                        <Grid container spacing={1}>
                          {/* Staff Section */}
                          {fristIndexMeeting?.no_of_participants && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid
                                container
                                alignItems="center"
                                spacing={"1px"}
                              >
                                <Grid item xs={12}>
                                  <Typography
                                    color="text.secondary"
                                    fontWeight={600}
                                  >
                                    No of Participants
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography color="primary">
                                    {fristIndexMeeting.no_of_participants || ""}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    )}
                    {fristIndexMeeting?.message && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          mt: 3,
                          px: 2,
                          py: 2,
                          backgroundColor: "#f5f5f5",
                          borderRadius: 2,
                        }}
                      >
                        <Grid container spacing={1}>
                          {/* Staff Section */}
                          {fristIndexMeeting?.message && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid
                                container
                                alignItems="center"
                                spacing={"1px"}
                              >
                                <Grid item xs={12}>
                                  <Typography
                                    color="text.secondary"
                                    fontWeight={600}
                                  >
                                    Message
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography color="primary">
                                    {fristIndexMeeting.message || ""}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    )}
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        mt: 3,
                        px: 2,
                        py: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Box
                            sx={{
                              borderBottom: { xs: "1px solid", sm: "none" },
                              borderColor: "divider",
                              pb: { xs: 2, sm: 0 },
                              mb: { xs: 2, sm: 0 },
                            }}
                          >
                            {fristIndexMeeting?.created_at && (
                              <Box
                                display="flex"
                                justifyContent="space-between"
                                mb={0.5}
                              >
                                <Typography
                                  // variant="caption"
                                  color="text.secondary"
                                >
                                  📅 Created On:
                                </Typography>
                                <Typography variant="body2">
                                  {dayjs(fristIndexMeeting.created_at).format(
                                    "MMM D, YYYY"
                                  )}
                                </Typography>
                              </Box>
                            )}

                            {/* {fristIndexMeeting?.created_by && ( */}
                            <Box display="flex" justifyContent="space-between">
                              <Typography
                                // variant="caption"
                                color="text.secondary"
                              >
                                🧑 Created By:
                              </Typography>
                              <Typography variant="body2">
                                {userMap.get(fristIndexMeeting?.created_by) ||
                                  "Website Registration"}
                              </Typography>
                            </Box>
                            {/* )} */}
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{
                        mt: 3,
                        px: 2,
                        py: 2,
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography
                            color="text.secondary"
                            fontWeight={600}
                            gutterBottom
                          >
                            🔔 Email Notifications After Registration
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {renderReminderChip(
                            "Admin confirmation",
                            fristIndexMeeting?.admin_email_received
                          )}
                          {renderReminderChip(
                            "Participant confirmation",
                            fristIndexMeeting?.participant_email_received
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                  {fristIndexMeeting?.status !== "done" &&
                    fristIndexMeeting?.status !== "cancel" && (
                      <CardActions
                        sx={{ background: theme.palette.cardAdd.thirdBgColor }}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          mt={2}
                          mb={2}
                        >
                          {fristIndexMeeting && (
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                            >
                              <Grid item>
                                <Button
                                  className={classes.mLButtonUpdate}
                                  onClick={() =>
                                    handleOpenDialog(fristIndexMeeting)
                                  }
                                >
                                  Edit
                                </Button>
                              </Grid>
                              {/* <Grid item>
                                <Button
                                  className={classes.mLButtonUpdate}
                                  onClick={() =>
                                    handleOpenDialogMeeting(fristIndexMeeting)
                                  }
                                >
                                  Reschedule
                                </Button>
                              </Grid> */}
                              {/* <Grid item>
                                <Button
                                  className={classes.mL12ButtonView}
                                  onClick={() =>
                                    handleOpenDonePopup(fristIndexMeeting)
                                  }
                                >
                                  Complete
                                </Button>
                              </Grid> */}
                              <Grid item>
                                <Button
                                  className={classes.mL12ButtonDelate}
                                  onClick={() =>
                                    handleOpenDeletePopup(fristIndexMeeting)
                                  }
                                >
                                  Delete
                                </Button>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                      </CardActions>
                    )}
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        <Grid item lg={8} md={12} sm={12} xs={12}>
          <Card
            elevation={2}
            sx={{
              height: "100%",
              // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
              p: "2px",
              borderRadius: setCardBRadius,
              minHeight: "70vh",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                {historyRecords.length > 0 && (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.card}>
                      <Grid item lg={12} md={12} sm={12} xs={12} p={2}>
                        <Box
                          sx={{
                            // minHeight: "60vh",
                            maxHeight: "100vh",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        >
                          <Stack spacing={2}>
                            {historyRecords.map((order, index) => {
                              const statusName = order.updated_by
                                ? "Updated"
                                : "Created";

                              const statusNameIcon = order.updated_by
                                ? "ChangedStatusOrange"
                                : "ChangedStatusGreen";

                              const userName =
                                userMap.get(order.created_by) || "";
                              return (
                                <Card
                                  key={order.id}
                                  variant="outlined"
                                  className={classes.orderListRightCard2}
                                >
                                  <CardContent>
                                    <Stack
                                      spacing={1}
                                      mb={1}
                                      // onClick={() =>
                                      //   toggleExpandHis(order.id)
                                      // }
                                      sx={{ cursor: "pointer" }}
                                    >
                                      <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        sx={{ mb: 1 }}
                                      >
                                        <Typography
                                          variant="h6"
                                          fontWeight={600}
                                        >
                                          {dayjs(order.created_at).format(
                                            "MMM D, YYYY h:mm A"
                                          )}
                                        </Typography>

                                        {/* <ExpandMore
                                              expand={
                                                expandedTemplateIdHis ===
                                                order.id
                                              }
                                              onClick={() =>
                                                toggleExpandHis(order.id)
                                              }
                                              aria-expanded={
                                                expandedTemplateIdHis ===
                                                order.id
                                              }
                                            >
                                              <ExpandMoreIcon />
                                            </ExpandMore> */}
                                      </Stack>

                                      <Stack
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        spacing={1}
                                        flexWrap="wrap"
                                      >
                                        <Typography
                                          variant="body2"
                                          className={
                                            classes.orderLsitHeadingTypoColor
                                          }
                                        >
                                          {order.name}
                                        </Typography>

                                        <Typography
                                          variant="body2"
                                          className={
                                            classes.orderLsitHeadingTypoColor
                                          }
                                        >
                                          {` | ${userName || "website"}`}
                                        </Typography>
                                      </Stack>
                                      <>
                                        <Stack spacing={1} mb={1}>
                                          <Stack
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            spacing={1}
                                            flexWrap="wrap"
                                          >
                                            {
                                              statusIcon[
                                                statusNameIcon as keyof typeof statusIcon
                                              ]
                                            }

                                            <Typography
                                              fontWeight={600}
                                              sx={{
                                                color:
                                                  statusName === "Created"
                                                    ? "green"
                                                    : "orange",
                                              }}
                                            >
                                              <strong>{statusName}</strong>
                                            </Typography>
                                          </Stack>
                                        </Stack>
                                      </>
                                    </Stack>
                                    <Stack spacing={1} mb={1}>
                                      {order.workshop_history.length > 0 ? (
                                        <Grid
                                        // in={
                                        //   expandedTemplateIdHis ===
                                        //   order.id
                                        // }
                                        // timeout="auto"
                                        // unmountOnExit
                                        >
                                          <Divider sx={{ mb: 2 }} />

                                          {/* Render rest of the history (index > 0) as changes */}
                                          {order.workshop_history
                                            .slice(1)
                                            .map((msg, index) => {
                                              const prev =
                                                order.workshop_history[index]; // prev is previous record
                                              const changes =
                                                msg.status === "Updated"
                                                  ? getChangedFields(
                                                      prev,
                                                      msg,
                                                      {}
                                                    )
                                                  : getChangedFields(
                                                      prev,
                                                      msg,
                                                      {}
                                                    );

                                              return (
                                                <Box key={msg.id} pb={4}>
                                                  {changes &&
                                                    changes.length > 0 && (
                                                      <>
                                                        <Stack
                                                          direction="row"
                                                          alignItems="center"
                                                          justifyContent="space-between"
                                                          sx={{ mb: 1 }}
                                                        >
                                                          <Typography
                                                            color="primary"
                                                            style={{
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            <Box
                                                              display="flex"
                                                              alignItems="center"
                                                              gap={1}
                                                            >
                                                              <PublishedWithChangesIcon
                                                                fontSize="medium"
                                                                color="primary"
                                                                style={{
                                                                  fontSize: 20,
                                                                  fontWeight: 600,
                                                                }}
                                                              />
                                                              {userMap.get(
                                                                msg.created_by
                                                              ) || ""}{" "}
                                                              made changes:
                                                            </Box>
                                                          </Typography>

                                                          <Typography variant="h6">
                                                            {dayjs(
                                                              msg.created_at
                                                            ).format(
                                                              "MMM D, YYYY h:mm A"
                                                            )}
                                                          </Typography>
                                                        </Stack>

                                                        {changes.map(
                                                          (change, idx) => {
                                                            const statusType =
                                                              getStatusType(
                                                                change.oldValue,
                                                                change.newValue
                                                              );

                                                            return (
                                                              <Box
                                                                key={idx}
                                                                mb={2}
                                                                ml={4}
                                                              >
                                                                <Stack
                                                                  direction="row"
                                                                  alignItems="center"
                                                                  spacing={1}
                                                                >
                                                                  {statusType &&
                                                                    statusIcon[
                                                                      statusType
                                                                    ]}
                                                                  <Typography
                                                                    variant="body2"
                                                                    display="flex"
                                                                    alignItems="center"
                                                                    gap={1}
                                                                  >
                                                                    {variantPropName(
                                                                      change.field
                                                                    )}{" "}
                                                                    {statusType ===
                                                                      "Created" && (
                                                                      <>
                                                                        added ➜{" "}
                                                                        {change.field ===
                                                                        "license_img" ? (
                                                                          <img
                                                                            src={
                                                                              change.newValue
                                                                            }
                                                                            alt="New"
                                                                            style={{
                                                                              width: 50,
                                                                              height: 50,
                                                                              objectFit:
                                                                                "cover",
                                                                              borderRadius: 4,
                                                                            }}
                                                                          />
                                                                        ) : (
                                                                          change.newValue
                                                                        )}
                                                                      </>
                                                                    )}
                                                                    {statusType ===
                                                                      "Modified" && (
                                                                      <>
                                                                        changed
                                                                        from{" "}
                                                                        {change.field ===
                                                                        "license_img" ? (
                                                                          <img
                                                                            src={
                                                                              change.oldValue
                                                                            }
                                                                            alt="Old"
                                                                            style={{
                                                                              width: 80,
                                                                              height: 50,
                                                                              objectFit:
                                                                                "cover",
                                                                              borderRadius: 4,
                                                                              marginRight: 8,
                                                                            }}
                                                                          />
                                                                        ) : (
                                                                          <s>
                                                                            {
                                                                              change.oldValue
                                                                            }
                                                                          </s>
                                                                        )}{" "}
                                                                        ➜{" "}
                                                                        {change.field ===
                                                                        "license_img" ? (
                                                                          <img
                                                                            src={
                                                                              change.newValue
                                                                            }
                                                                            alt="New"
                                                                            style={{
                                                                              width: 80,
                                                                              height: 50,
                                                                              objectFit:
                                                                                "cover",
                                                                              borderRadius: 4,
                                                                            }}
                                                                          />
                                                                        ) : (
                                                                          change.newValue
                                                                        )}
                                                                      </>
                                                                    )}
                                                                    {statusType ===
                                                                      "Deleted" && (
                                                                      <>
                                                                        removed
                                                                        (was{" "}
                                                                        {change.field ===
                                                                        "license_img" ? (
                                                                          <img
                                                                            src={
                                                                              change.oldValue
                                                                            }
                                                                            alt="Old"
                                                                            style={{
                                                                              width: 80,
                                                                              height: 50,
                                                                              objectFit:
                                                                                "cover",
                                                                              borderRadius: 4,
                                                                            }}
                                                                          />
                                                                        ) : (
                                                                          change.oldValue
                                                                        )}
                                                                        )
                                                                      </>
                                                                    )}
                                                                  </Typography>

                                                                  {/* <Typography variant="body2">
                                                                        {variantPropName(
                                                                          change.field
                                                                        )}{" "}
                                                                        {statusType ===
                                                                          "Created" && (
                                                                          <>
                                                                            added
                                                                            ➜{" "}
                                                                            {
                                                                              change.newValue
                                                                            }
                                                                          </>
                                                                        )}
                                                                        {statusType ===
                                                                          "Modified" && (
                                                                          <>
                                                                            changed
                                                                            from{" "}
                                                                            <s>
                                                                              {
                                                                                change.oldValue
                                                                              }
                                                                            </s>{" "}
                                                                            ➜{" "}
                                                                            {
                                                                              change.newValue
                                                                            }
                                                                          </>
                                                                        )}
                                                                        {statusType ===
                                                                          "Deleted" && (
                                                                          <>
                                                                            removed
                                                                            (was{" "}
                                                                            {
                                                                              change.oldValue
                                                                            }
                                                                            )
                                                                          </>
                                                                        )}
                                                                      </Typography> */}
                                                                </Stack>
                                                              </Box>
                                                            );
                                                          }
                                                        )}
                                                      </>
                                                    )}
                                                </Box>
                                              );
                                            })}

                                          {(() => {
                                            const msg =
                                              order.workshop_history[0];
                                            const createdFields =
                                              getCreatedFields(msg, {});

                                            return (
                                              <Box key={msg.id} pb={4}>
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  justifyContent="space-between"
                                                  sx={{ mb: 1 }}
                                                >
                                                  <Typography
                                                    color="primary"
                                                    style={{
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      gap={1}
                                                    >
                                                      <PublishedWithChangesIcon
                                                        fontSize="medium"
                                                        color="primary"
                                                        style={{
                                                          fontSize: 20,
                                                          fontWeight: 600,
                                                        }}
                                                      />
                                                      {userMap.get(
                                                        msg.created_by
                                                      ) || ""}{" "}
                                                      created record:
                                                    </Box>
                                                  </Typography>

                                                  <Typography variant="h6">
                                                    {dayjs(
                                                      msg.created_at
                                                    ).format(
                                                      "MMM D, YYYY h:mm A"
                                                    )}
                                                  </Typography>
                                                </Stack>

                                                {createdFields.map(
                                                  (item, idx) => (
                                                    <Box
                                                      key={idx}
                                                      mb={2}
                                                      ml={4}
                                                    >
                                                      <Stack
                                                        direction="row"
                                                        alignItems="center"
                                                        spacing={1}
                                                      >
                                                        {statusIcon["Created"]}
                                                        <Typography
                                                          variant="body2"
                                                          display="flex"
                                                          alignItems="center"
                                                          gap={1}
                                                        >
                                                          {variantPropName(
                                                            item.field
                                                          )}{" "}
                                                          added ➜{" "}
                                                          {item.field ===
                                                          "license_img" ? (
                                                            <img
                                                              src={item.value}
                                                              alt="New"
                                                              style={{
                                                                width: 80,
                                                                height: 50,
                                                                objectFit:
                                                                  "cover",
                                                                borderRadius: 4,
                                                              }}
                                                            />
                                                          ) : (
                                                            item.value
                                                          )}
                                                        </Typography>

                                                        {/* <Typography variant="body2">
                                                              {variantPropName(
                                                                item.field
                                                              )}{" "}
                                                              added ➜{" "}
                                                              {item.value}
                                                            </Typography> */}
                                                      </Stack>
                                                    </Box>
                                                  )
                                                )}
                                              </Box>
                                            );
                                          })()}
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12}>
                                          <Typography
                                            variant="body2"
                                            color="text.secondary"
                                          >
                                            No history available
                                          </Typography>
                                        </Grid>
                                      )}
                                    </Stack>
                                  </CardContent>
                                </Card>
                              );
                            })}
                          </Stack>
                        </Box>
                      </Grid>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {selectedCoursing && (
          <NewPopUpDepartment
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}

        {/* {selectedMeeting && (
          <RescheduleMeeting
            openModel={openDialogMeeting}
            handleCloseDialog={handleCloseDialogMeeting}
            data={selectedMeeting}
          />
        )} */}

        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Participant"
            content={`Are you sure you want to delete the Participant "${coursingToDelete.name}"? This action cannot be undone.`}
          />
        )}

        {/* {meetingToDone && (
          <AlertPopup
            open={openDoneMeeting}
            handleCloseDelete={handleCloseDonePopup}
            onConfirm={async () => {
              await handleDeleteDoneMeeting(meetingToDone.id.toString());
            }}
            title="Mark Task as completed"
            content={`Are you sure you want to complete the task "${meetingToDone.subject}"? This will mark it as done.`}
          />
        )} */}
      </Grid>
    </div>
  );
};

export default Index;
